import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ViewOddsPlayerGroup from './ViewOddsPlayerGroup';
import styled from 'styled-components';

const firstLastAnyTimeGoalTypes = [495, 494, 17, 2, 167];
const twoThreeOrLastTypeGoalTypes = [21, 283, 287];

const GroupLabel = styled.h5`
    font-size: 14px;
    color: #585858;
    margin: 10px 15px;
`;

const TabsWrapper = styled.div`
    width: 95%;
    margin: 0 auto;
    display: flex;
    height: 30px;
    justify-content: center;
    & > :first-child {
        border-radius: 5px 0 0 5px;
    }
    & > :last-child {
        border-radius: 0 5px 5px 0;
    }
`;
const Tab = styled.div`
    font-size: 14px;
    display: flex;
    flex-basis: 33%;
    height: 100%;
    cursor: pointer;
    line-height: 30px;
    justify-content: center;
    color: ${({ active }) => (active ? '#FFFFFF' : '#585858')};
    background: ${({ active }) => (active ? '#1C3E60' : '#e9ebee')};
`;

const Tabs = ({ filteredMarkets, activeTab, setActiveTab }) => {
    return (
        <TabsWrapper>
            <Tab
                onClick={() => {
                    setActiveTab(0);
                }}
                active={activeTab === 0}
            >
                Enkelte mål
            </Tab>
            {filteredMarkets.length > 1 && (
                <Tab
                    onClick={() => {
                        setActiveTab(1);
                    }}
                    active={activeTab === 1}
                >
                    Flere mål
                </Tab>
            )}
            {filteredMarkets.length > 2 && (
                <Tab
                    onClick={() => {
                        setActiveTab(2);
                    }}
                    active={activeTab === 2}
                >
                    Andet
                </Tab>
            )}
        </TabsWrapper>
    );
};

/**
 *
 * @param markets
 * @param marketSubTypes
 * @param invertFilter
 * @return {*[]}
 */
const filterPlayersByTeamAndMarket = (
    markets,
    marketSubTypes = null,
    invertFilter = false
) => {
    const filteredMarkets = [...markets];
    //.filter((item) => item.odds > 1)
    filteredMarkets.sort((a, b) => {
        return a.marketSubType - b.marketSubType;
    });
    return filteredMarkets.filter(
        (market) =>
            invertFilter
                ? marketSubTypes.indexOf(market.marketSubType) < 0
                : marketSubTypes.indexOf(market.marketSubType) >= 0
    );
};
/**
 *
 * @param markets
 * @return {[]}
 */
const prepareMarkets = (markets) => {
    return [
        [
            filterPlayersByTeamAndMarket(markets, [
                ...firstLastAnyTimeGoalTypes,
            ]),

            filterPlayersByTeamAndMarket(markets, [
                ...twoThreeOrLastTypeGoalTypes,
            ]),

            filterPlayersByTeamAndMarket(
                markets,
                [...firstLastAnyTimeGoalTypes, ...twoThreeOrLastTypeGoalTypes],
                true
            ),
        ].filter((market) => market.length > 0),
    ];
};
const PlayerGroup = ({ markets, allMarkets, teamIndex }) => {
    const [activeTab, setActiveTab] = useState(0);
    const playerGroups = prepareMarkets(markets);

    return (
        <Fragment>
            {playerGroups
                ? playerGroups.map((filteredMarkets, index) => (
                      <Fragment key={index}>
                          {/*<GroupLabel>
                              {teamIndex === 0
                                  ? 'Målscorere - Hjemmehold'
                                  : 'Målscorere - Udehold'}
                          </GroupLabel>*/}
                          {filteredMarkets.length > 1 ? (
                              <Tabs
                                  filteredMarkets={filteredMarkets}
                                  activeTab={activeTab}
                                  setActiveTab={setActiveTab}
                              />
                          ) : null}

                          <ViewOddsPlayerGroup
                              allMarkets={allMarkets}
                              columnKey={'marketName'}
                              marketList={filteredMarkets[activeTab]}
                              rowLimit={7}
                          />
                      </Fragment>
                  ))
                : null}
        </Fragment>
    );
};

PlayerGroup.propTypes = {
    markets: PropTypes.arrayOf(PropTypes.object),
    allMarkets: PropTypes.arrayOf(PropTypes.object),
    teamIndex: PropTypes.number,
};
PlayerGroup.defaultProps = {
    markets: null,
    allMarkets: null,
    teamIndex: 0,
};

export default PlayerGroup;
